module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-7-116a99686978e5c7deaf99499d3d8497.svg";